import React, { Component } from 'react';
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";

let t = null;

class TextCounter extends Component {
    constructor(props) {
        super(props);
        t = props.t;
        this.aboutUsMaxCharCount = 4000;
        this.hasCalledChangeComponents = false;
        this.debounceTimer = null;
        
        const initialValue = (props.title && typeof props.title.value === 'string') 
            ? props.title.value 
            : (props.title?.value || '');
        
        this.state = {
            localValue: initialValue
        };
    }

    componentDidUpdate(prevProps) {
        const prevValue = prevProps.title?.value || '';
        const currentValue = this.props.title?.value || '';
        
        if (prevValue !== currentValue && currentValue !== this.state.localValue) {
            this.setState({ localValue: currentValue });
        }
    }

    componentWillUnmount() {
        // Cleanup debounce timer
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    handleChange = (e) => {
        const newValue = e.target.value;
        const { index, onChange, changeComponentsWithTextCounter } = this.props;

        this.setState({ localValue: newValue });

        if (!this.hasCalledChangeComponents && typeof changeComponentsWithTextCounter === 'function') {
            changeComponentsWithTextCounter();
            this.hasCalledChangeComponents = true;
        }

        // Debounce ile parent'ı güncelle (150ms gecikme)
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            if (typeof onChange === 'function') {
                onChange(index, newValue);
            }
        }, 150);
    };

    render() {
        const { title } = this.props;
        const { localValue } = this.state;

        const languageCode = title?.language_code || '';
        const charCount = typeof localValue === 'string' ? localValue.length : 0;

        return (
            <>
                <TextField
                    name={languageCode}
                    type="text"
                    variant="outlined"
                    className="text-capitalize"
                    value={localValue}
                    onChange={this.handleChange}
                    label={`${t('enw-myweb-edit-about_us-title')} - ${languageCode}`}
                    multiline={true}
                    fullWidth
                    required={false}
                    rows={9}
                    inputProps={{ maxLength: this.aboutUsMaxCharCount }}
                />
                <div style={{ width: '100%' }}>
                    <p style={{ float: 'right' }}>{charCount}/{this.aboutUsMaxCharCount}</p>
                </div>
            </>
        );
    }
}

export default compose(withTranslation('common'))(TextCounter);